import { CWILL_EVENT_NAMES } from "@channelwill/report"
import { isShopifyEmbedded } from "@shopify/app-bridge-utils"

import { DashboardSetupGuideEnum } from "@/enums/dashboard"

const SETUP_GUIDE_STEP_ORDER: DashboardSetupGuideEnum[] = [
  DashboardSetupGuideEnum.ADD_TRACKING_PAGE,
  DashboardSetupGuideEnum.CUSTOMIZE_SHIPPING_NOTIFICATIONS,
  DashboardSetupGuideEnum.DROPSHIPPING_MODE,
  DashboardSetupGuideEnum.HOW_PP_WORKS,
]

interface SetupGuideTask {
  id: DashboardSetupGuideEnum
  is_completed: boolean
}

interface SetupGuideData {
  task: SetupGuideTask[]
}

const getSetupGuideStepNumber = (stepId: DashboardSetupGuideEnum) => {
  const stepIndex = SETUP_GUIDE_STEP_ORDER.indexOf(stepId)

  return stepIndex === -1 ? stepIndex : stepIndex + 1
}

export const reportSetupGuideStepComplete = (
  setupGuide: SetupGuideData,
  stepId: DashboardSetupGuideEnum,
) => {
  const stepNumber = getSetupGuideStepNumber(stepId)

  if (stepNumber <= 0) {
    return
  }

  window.cwreport && window.cwreport.report(CWILL_EVENT_NAMES.COMPLETE_GUIDE_STEP, {
    step_index: stepNumber,
    completed_steps: setupGuide.task.filter(task => task.is_completed).length,
    total_steps: setupGuide.task.length,
  })

  try {
    const unCompleteIndex = setupGuide.task.findIndex(item => !item.is_completed)

    if (unCompleteIndex === -1 && window.isFromAdmin !== true && isShopifyEmbedded()) {
      window.cio && window.cio.trigger({
        event: "complete_quick_guide",
      })

      window.cwreport && window.cwreport.report(CWILL_EVENT_NAMES.COMPLETE_QUICK_GUIDE)
    }
  } catch (e) {
    console.log(e)
  }
}
